import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SelectKontokt from "../../../SkapaMote/Inputs/SelectKontokt";
import KontaktFName from "../../../SkapaMote/Inputs/KontaktFName";
import KontaktLName from "../../../SkapaMote/Inputs/KontaktLName";
import KontaktTele from "../../../SkapaMote/Inputs/KontaktTele";
import KontaktEmail from "../../../SkapaMote/Inputs/KontaktEmail";
import KontaktRoll from "../../../SkapaMote/Inputs/KontaktRoll";
import KontaktPersonnummer from "../../../SkapaMote/Inputs/KontaktPersonnummer";
import InViteKontaktInput from "../../../SkapaMote/Inputs/InViteKontaktInput";
//import Divider from "@material-ui/core/Divider";
//import {isEmpty} from 'lodash'

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

function Kontakt(props) {
  //  const classes = useStyles();
    console.log(props.Kontakt)
      return (
        <div>
            <div style={{ paddingTop: '5px' }} className="row">
                <div className="col-12 my-2"  style={{ height: 'auto' }}>
                    <SelectKontokt 
                    isRequired={true}
                    Kontakter={props.Kontakter}
                    Kontokt={props.Kontakt}
                    onchangeHanelKontakt={props.onchangeHanelKontakt}
                    />
                </div>
                {
                    props.Kontakt.id === ""?"":
                    <>
                    <div className={ parseInt(props.userRole) === 4?"col-6 my-2":"col-4 my-2"}  style={{ height: 'auto' }}>
                        <KontaktFName
                        id={props.Kontakt.id}
                        FirstName={props.Kontakt.FirstName}
                        onchangeHanelKontakt={props.onchangeHanelKontakt2}
                        />
                    </div>
                    <div className={ parseInt(props.userRole) === 4?"col-6 my-2":"col-4 my-2"}  style={{ height: 'auto' }}>
                        <KontaktLName
                        id={props.Kontakt.id}
                        LastName={props.Kontakt.LastName}
                        onchangeHanelKontakt={props.onchangeHanelKontakt2}
                        />
                        </div>
                        { 
                        parseInt(props.userRole) === 4?"":
                        <div className="col-4 my-2"  style={{ height: 'auto' }}>
                            <InViteKontaktInput
                            InViteKontakt={props.InViteKontakt}
                            onchangeHandle={props.onchangeHanelInViteKontakt}
                            />
                        </div>
                        }
                    <div className="col-6 my-2"  style={{ height: 'auto' }}>
                        <KontaktTele
                        id={props.Kontakt.id}
                        Tele={props.Kontakt.Tele}                    
                        onchangeHanelKontakt={props.onchangeHanelKontakt2}
                        />
                    </div>
                    <div className="col-6 my-2"  style={{ height: 'auto' }}>
                        <KontaktEmail
                        id={props.Kontakt.id}
                        Email={props.Kontakt.Email}
                        onchangeHanelKontakt={props.onchangeHanelKontakt2}
                        />
                    </div>
                    <div className="col-6 my-2"  style={{ height: 'auto' }}>
                        <KontaktPersonnummer
                        id={props.Kontakt.id}
                        Personnummer={props.Kontakt.PersonNr}
                        onchangeHanelKontakt={props.onchangeHanelKontakt2}
                        />
                    </div>
                    <div className="col-6 my-2"  style={{ height: 'auto' }}>
                        <KontaktRoll
                        id={props.Kontakt.id}
                        Role={props.Kontakt.Role}
                        onchangeHanelKontakt={props.onchangeHanelKontakt2}
                        />
                    </div>
                    </>
                }
            </div>
        </div>
    );
}

export default Kontakt;